(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8529],{

/***/ 51192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UList_UList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/UList.js







const UListItem = (param)=>{
    let { bulletColor , size , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,classes/* classes */.S)("li", size && "text-".concat(size), bulletColor && "li--bullet-color-".concat(bulletColor), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
UListItem.propTypes = {
    size: props_sx/* fontSizePropTypes */.Gk,
    bulletColor: (0,prop_types.oneOf)([
        "orange",
        "dotmatics-7",
        "black--custom-1"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const UList = (param)=>{
    let { type ="default" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("ul", "ul-".concat(type), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
UList.propTypes = {
    type: (0,prop_types.oneOf)([
        "default",
        "pros",
        "cons"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
UList.Item = UListItem;
/* harmony default export */ var UList_UList = (UList);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 75833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pipeA */
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const pipe = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>fn(val), value);
};
const pipeA = function(value) {
    for(var _len = arguments.length, fns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        fns[_key - 1] = arguments[_key];
    }
    return fns.reduce((val, fn)=>(0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(val) ? val.then(fn) : fn(val), value);
};
pipe.async = pipeA;
/* harmony default export */ __webpack_exports__["Z"] = (pipe);


/***/ }),

/***/ 86870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L4": function() { return /* binding */ mapGqlError; },
/* harmony export */   "ZO": function() { return /* binding */ isExpectedGqlError; },
/* harmony export */   "o3": function() { return /* binding */ GqlError; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10455);


const join = (path)=>Array.isArray(path) ? path.join(".") : path;
class GqlError extends Error {
    constructor(originalError){
        const { code , message , path  } = originalError;
        super("GraphQL Error in ".concat(join(path), ": ").concat(code, " - ").concat(message));
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "name", "GqlError");
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, "isGraphQlError", true);
        this.code = code;
        this.path = join(path);
        this.originalError = originalError;
    }
}
/**
 * Creates predicate to match Expected GqlErrors.
 */ const isExpectedGqlError = function() {
    for(var _len = arguments.length, expected = new Array(_len), _key = 0; _key < _len; _key++){
        expected[_key] = arguments[_key];
    }
    return (err)=>{
        return (err === null || err === void 0 ? void 0 : err.isGraphQlError) === true && (expected.length === 0 || expected.includes(err.code));
    };
};
const toCode = (value)=>{
    const code = +value;
    return Number.isNaN(code) ? value : code;
};
/**
 * Maps expected GQL Error to other value
 */ const mapGqlError = (codeMap)=>{
    const isExpected = isExpectedGqlError(...Object.keys(codeMap).map(toCode));
    return (error)=>{
        if (!isExpected(error)) throw error;
        const mappedValue = codeMap[error.code];
        return (0,_fn__WEBPACK_IMPORTED_MODULE_1__/* .isFunc */ .Wl)(mappedValue) ? mappedValue(error) : mappedValue;
    };
};


/***/ }),

/***/ 82990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "TV": function() { return /* binding */ createGqlClient; },
  "L4": function() { return /* reexport */ GqlError/* mapGqlError */.L4; }
});

// UNUSED EXPORTS: GqlError, HttpError, isExpectedGqlError

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/assert/index.js
/** @type {(condition: any, message: string) => true} */ const assert = (condition, message)=>{
    const isOk = Boolean(condition);
    if (isOk) return isOk;
    throw new TypeError(message);
};
/** @type {(value: never, message: string | ((value: any) => string)) => never} */ function assertNever(value, message) {
    const errorMessage = typeof message === "function" ? message(value) : message;
    throw new TypeError(errorMessage);
}

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/GqlError.js
var GqlError = __webpack_require__(86870);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/HttpError.js

class HttpError extends Error {
    constructor(res){
        const { status , statusText  } = res;
        super("Request Failed: ".concat(status, " - ").concat(statusText !== null && statusText !== void 0 ? statusText : ""));
        (0,_define_property/* default */.Z)(this, "name", "HttpError");
        this.code = status;
    }
}

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/fetcher.js



const BASE_HEADERS = {
    "Content-Type": "application/json",
    Accept: "application/json"
};
const parseResponse = (res)=>res.ok ? res.json() : Promise.reject(new HttpError(res));
const throwGqlError = (result)=>result instanceof GqlError/* GqlError */.o3 ? Promise.reject(result) : result;
const readData = (param)=>{
    let { data , errors  } = param;
    return errors ? new GqlError/* GqlError */.o3(errors[0] || errors) : data;
};
const gqlFetcher = function(uri, baseHeaders) {
    let fetchFn = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : __webpack_require__.g.fetch;
    return function(operation) {
        let { headers , ...options } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return fetchFn(uri, {
            method: "POST",
            ...options,
            headers: {
                ...BASE_HEADERS,
                ...baseHeaders,
                ...headers
            },
            body: JSON.stringify(operation)
        }).then(parseResponse).then((0,fn/* vmap */.$M)(readData)).then(throwGqlError);
    };
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/operation.js + 1 modules
var operation = __webpack_require__(97687);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/index.js






const decorateFetcher = (fetcher, middlewares)=>{
    let execute;
    const restart = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return execute(...args);
    };
    execute = middlewares.reduceRight((next, middleware)=>middleware(next, restart, fetcher), fetcher);
    return execute;
};
/**
 * Creates GraphQL client (runner for GraphQL queries)
 */ const createGqlClient = function(param) {
    let { uri , fetch , headers  } = param;
    for(var _len = arguments.length, middlewares = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        middlewares[_key - 1] = arguments[_key];
    }
    assert(typeof uri === "string" && uri, "Expected uri to be not empty string but received: ".concat(uri));
    const fetcher = decorateFetcher(gqlFetcher(uri, headers, fetch), middlewares.filter(fn/* isFunc */.Wl));
    return function(queryBuilder, variables) {
        let context = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        return fetcher((0,operation/* Operation */.O)(queryBuilder, variables), context);
    };
};


/***/ }),

/***/ 51378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dC": function() { return /* reexport */ batch; },
  "Do": function() { return /* reexport */ context; },
  "sQ": function() { return /* reexport */ recovery; },
  "bw": function() { return /* reexport */ tap; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/GqlError.js
var GqlError = __webpack_require__(86870);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/batch.js

/**
 * Creates a batching decorator for GraphQlFetcher
 */ const batchMiddleware = function() {
    let deferFn = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : setTimeout;
    return (next)=>{
        let deferId = null;
        let lastContext;
        let operations = [];
        let resolvers = [];
        const appendOperation = (operation, context)=>(resolve, reject)=>{
                operations.push(operation);
                resolvers.push({
                    resolve,
                    reject
                });
                lastContext = context;
                deferId = deferId || deferFn(()=>{
                    const currentOperations = [
                        ...operations
                    ];
                    const currentResolvers = [
                        ...resolvers
                    ];
                    deferId = null;
                    operations = [];
                    resolvers = [];
                    next(currentOperations, lastContext).then((results)=>results.forEach((result, index)=>result instanceof GqlError/* GqlError */.o3 ? currentResolvers[index].reject(result) : currentResolvers[index].resolve(result))).catch((err)=>currentResolvers.forEach((resolver)=>resolver.reject(err)));
                });
            };
        return (operation, context)=>new Promise(appendOperation(operation, context));
    };
};
/* harmony default export */ var batch = (batchMiddleware);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/context.js

/**
 * Creates Context Initialization decorator for GqlFetcher
 */ const contextMiddleware = (initializer)=>(next)=>(operation, context)=>{
            const runNext = (newContext)=>next(operation, newContext !== null && newContext !== void 0 ? newContext : context);
            try {
                const initResult = initializer(context, operation);
                return (0,fn/* isPromise */.tI)(initResult) ? initResult.then(runNext) : runNext(initResult);
            } catch (err) {
                return Promise.reject(err);
            }
        };
/* harmony default export */ var context = (contextMiddleware);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/recovery.js

const recoverAndRestart = (operation, context, recover, restart, next, last)=>{
    const recoveryResult = recover(context, operation, {
        client: restart,
        forward: next,
        last
    });
    const doRestart = (newContext)=>restart(operation, newContext !== null && newContext !== void 0 ? newContext : context);
    return (0,fn/* isPromise */.tI)(recoveryResult) ? recoveryResult.then(doRestart) : doRestart(recoveryResult);
};
/**
 * Creates recovering decorator for GqlFetcher
 */ const recoveryMiddleware = (shouldBeRecovered, recover)=>(next, restart, last)=>(operation, context)=>next(operation, context).catch((err)=>shouldBeRecovered(err, operation) ? recoverAndRestart(operation, context, recover, restart, next, last) : Promise.reject(err));
/* harmony default export */ var recovery = (recoveryMiddleware);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/tap.js
const tapMiddleware = function() {
    let { onSuccess , onError  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return (next)=>(operation, context)=>next(operation, context).then((result)=>{
                try {
                    if (typeof onSuccess === "function") onSuccess(operation, result, context);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                }
                return result;
            }).catch((error)=>{
                try {
                    if (typeof onError === "function") onError(operation, error, context);
                } catch (err) {
                    // eslint-disable-next-line no-console
                    console.error(err);
                }
                return Promise.reject(error);
            });
};
/* harmony default export */ var tap = (tapMiddleware);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/middlewares/index.js










/***/ }),

/***/ 97687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ Operation; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/parsers/getOperationName.js

const getFirst = (0,fn/* get */.U2)(1);
/**
 * Parses GraphQL query and extracts the operation name
 *
 * @type {(query: string) => string}
 *
 */ const getOperationName = (query)=>getFirst(/(?:query|mutation)\s+([^({\s]*)/m.exec(query)) || "";

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlClient/operation.js

/**
 * Creates an operation object
 */ const Operation = function(query) {
    let variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const body = typeof query === "function" ? query(variables) : query;
    const operationName = getOperationName(body);
    return {
        operationName,
        query: body,
        variables
    };
};


/***/ }),

/***/ 29995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ gqlEvents; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/Emitter/subscriptions.js
var Emitter_subscriptions = __webpack_require__(12300);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/Emitter/index.js

const addListener = (subscriptions)=>(event, listener)=>{
        let eventSubscription = subscriptions.get(event);
        if (!eventSubscription) {
            eventSubscription = (0,Emitter_subscriptions/* default */.Z)();
            subscriptions.set(event, eventSubscription);
        }
        return eventSubscription.subscribe(listener);
    };
const notifyListeners = (subscriptions)=>function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        const eventSubscription = subscriptions.get(event);
        if (!eventSubscription) return;
        eventSubscription.notify(...args);
    };
const emitterApi = (subscriptions)=>({
        on: addListener(subscriptions),
        notify: notifyListeners(subscriptions)
    });
/**
 * Creates new lightweight event emitter
 *
 * @type {() => import("./types").IEmitter}
 */ const Emitter = ()=>emitterApi(new Map());
/* harmony default export */ var shared_utils_Emitter = (Emitter);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/gqlEvents/index.js

/**
 * Creates an events api
 *
 * @type {(
 * 	successEmitter: import("../Emitter/types").IEmitter,
 * 	errorEmitter: import("../Emitter/types").IEmitter,
 * ) => import("./types").IGqlEventsApi}
 */ const eventsApi = (successEmitter, errorEmitter)=>({
        on: successEmitter.on,
        onError: errorEmitter.on,
        listener: {
            onSuccess: (operation, result, context)=>successEmitter.notify(operation.operationName, operation.variables, result, context),
            onError: (operation, error, context)=>errorEmitter.notify(operation.operationName, operation.variables, error, context)
        }
    });
/**
 * Creantes GqlEvents PubSub
 * @type {() => import("./types").IGqlEventsApi}
 */ const GqlEvents = ()=>eventsApi(shared_utils_Emitter(), shared_utils_Emitter());
/* harmony default export */ var gqlEvents = (GqlEvents);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73445);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var true_di__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97357);
/* harmony import */ var _DiPageHoC_DiPageHoC__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91491);


const createContainer = (pageServices, coreServices)=>(context)=>(0,true_di__WEBPACK_IMPORTED_MODULE_1__["default"])({
            globalContext: ()=>context,
            ...coreServices,
            ...pageServices
        });
const NextPageWithServices = (coreServices)=>(Page)=>(0,_DiPageHoC_DiPageHoC__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(createContainer(Page.services, coreServices))(Page);
/* harmony default export */ __webpack_exports__["Z"] = (NextPageWithServices);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(83121)


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ })

}]);